import { CSCompensation } from "@components/features/CSCompensation";
import CSCompensationDialog from "@components/features/CSCompensation/CSCompensationDialog";
import { SkinnerBox } from "@components/features/SkinnerBox";
import useCSCompensation from "@hooks/useCSCompensation";
import useSkinnerBoxStatus from "@hooks/useSkinnerBoxStatus";
import { PropsWithClassName, cn } from "kz-ui-sdk";

interface PromotionFABGroupProps extends PropsWithClassName {}

const PromotionFABGroup = ({ className }: PromotionFABGroupProps) => {
  const {
    // SkinnerBox
    shouldShowSkinnerBox,
    skinnerBoxClaimableAmount,
    skinnerBoxKey,
    handleLeaveAnimationCompleted,
  } = useSkinnerBoxStatus();

  const { shouldShowCSCompensation, openCSCompensation } = useCSCompensation();

  if (!shouldShowCSCompensation && !shouldShowSkinnerBox) {
    return null;
  }

  return (
    <div className={cn("fixed bottom-[56px] right-1/2 z-[20] w-full max-w-md translate-x-1/2", className)}>
      <div className="absolute bottom-0 right-0 flex w-auto max-w-md flex-col items-center">
        {/* CS Compensation sits above Skinner Box; will slide down when Skinner Box disappears */}
        {shouldShowCSCompensation && <CSCompensation onClick={openCSCompensation} />}

        {shouldShowSkinnerBox && !!skinnerBoxClaimableAmount && (
          <SkinnerBox
            key={skinnerBoxKey}
            claimableAmount={skinnerBoxClaimableAmount}
            onLeaveAnimationCompleted={handleLeaveAnimationCompleted}
          />
        )}
      </div>

      {/* Mount dialog once; opens via custom event */}
      <CSCompensationDialog />
    </div>
  );
};

export default PromotionFABGroup;
